import {
    states,
    big_win,
    inbigwin,
    inmoneyadd,
    set_inanim,
    set_inbigwin,
    set_inmoneyadd, set_inwincount
} from "../framework/src/engine/madnes/madnes_variables";
import {
    bet,
    madnes_end_round, madnes_get_money_bet,
    madnes_win_anim_reset,
    win
} from "../framework/src/engine/madnes/madnes";
import {madnes_start_coin} from "../framework/src/engine/madnes/madnes_anims";
import {anims_money_add_win_anim, money_add_big_win_anim} from "./turbo27_anims";
import {STATES} from "../framework/src/states/states";

export function money_add_control()
{
    if(inmoneyadd || inbigwin)
    {
        setTimeout(function() {
            money_add_control();
        }, 100);
        return;
    }

    madnes_win_anim_reset();
    // madnes_show_stop();

    set_inwincount(false);

    if((win * 1 >= (madnes_get_money_bet(bet)) * big_win))
    {
        ctrl_end_round_biwin();
        return;
    }

    if(win * 1 > 0)
    {
        money_add_win();
        return;
    }

    set_inanim(0);
    set_inmoneyadd(0);
    set_inbigwin(0);

    ctrl_end_round_nowin();
}

function ctrl_end_round_nowin() {

    madnes_end_round();

    // // if(is_in_autostart()) {
    // // 	madnes_show_btns();
    // // }
    //
    // madnes_end_round(true, {}, {}, function() {
    //
    // 	// madnes_show_btns();
    // 	// madnes_hide_stop();
    //
    // 	end_result_control();
    // });
}

function ctrl_end_round_win() {
    madnes_end_round();
}

function ctrl_end_round_biwin() {

    set_inbigwin(1);
    // madnes_hide_btns();

    states.setState(STATES.BONUS_WIN);

//	setTimeout(madnes_start_coin, 800);

    madnes_start_coin();

    money_add_big_win_anim(win, false).then(function() {

        set_inanim(0);
        set_inmoneyadd(0);
        set_inbigwin(0);

        ctrl_end_round_win(win);
    });
}

function money_add_win()
{
    set_inmoneyadd(1);
    set_inbigwin(0);

    anims_money_add_win_anim(win).then(function () {

        set_inanim(0);
        set_inmoneyadd(0);
        set_inbigwin(0);

        ctrl_end_round_win(win);
    });
}

export function ctrl_end_round_freespins() {

    states.setState(STATES.BONUS_WIN);

    set_inbigwin(1);
    // madnes_hide_btns();

    madnes_start_coin();

    money_add_big_win_anim(win, true).then(function() {

        set_inanim(0);
        set_inmoneyadd(0);
        set_inbigwin(0);

        madnes_end_round();

        // var fsData = {
        //     win: fs_win,
        //     order: fs_order,
        //     count: fs_count
        // };

        // madnes_end_round(true, {}, fsData, function()
        // {
        // 	madnes_set_cookie("lfspos_" + server_config.session_id, "", -1);
        // 	end_result_control();
        // });
    });
}

// function end_result_control()
// {
//     madnes_on_end_round_recount(win);
//     madnes_on_round_end();
//     madnes_recount_bet();
//
//     madnes_show_btns();
//
//     autospin_force_enabled = false;
//     if(is_in_autostart() || autospin_force)
//     {
//         autospin_force = false;
//         madnes_rotate_start();
//     }
// }